import firebase from "firebase";
import useSWR from "swr";

import type { EventVideo } from "@spwn/types/firebase/firestore";
import type { SWRResponse } from "swr";

const generateKey = ({
  eventId,
  videoId,
}: {
  eventId: string;
  videoId: string;
}) => ({
  path: "getStreamingEvent",
  eventId,
  videoId,
});

type UseGetStreamingVideo = (args: {
  eventId?: string;
  videoId?: string;
}) => SWRResponse<EventVideo>;

export const useGetStreamingVideo: UseGetStreamingVideo = ({
  eventId,
  videoId,
}) => {
  return useSWR(
    // 必須パラメータが揃わない場合は fetch しない（未指定での無効化を意図した呼び出しに対応）
    eventId && videoId
      ? generateKey({
          eventId,
          videoId,
        })
      : null,
    async ({ eventId, videoId }) => await fetchStreamingVideo(eventId, videoId)
  );
};

const fetchStreamingVideo = async (eventId: string, videoId: string) => {
  const snapshot = await firebase
    .firestore()
    .collection("streaming")
    .doc(eventId)
    .collection("videos")
    .doc(videoId)
    .get();

  const data = {
    ...snapshot.data(),
    _id: snapshot.id,
  } as EventVideo;

  return data;
};
